import script from "./Graphics.vue?vue&type=script&setup=true&lang=js"
export * from "./Graphics.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__